import React from "react";

import CodeEditor from "../../../../../components/elements/CodeEditor";

export default function SolutionEditor({
                                           workspace,
                                           solution,
                                           path,
                                           updateAtPath
                                       }) {

    return (
        <div className="flex flex-col gap-6">

            <h2 className="text-2xl font-semibold">
                Reference Solution
            </h2>

            <div className="border rounded-md overflow-hidden">

                <CodeEditor
                    language={workspace.language}
                    value={solution?.code ?? ""}
                    onChange={(value) =>
                        updateAtPath([...path, "code"], value)
                    }
                />

            </div>

        </div>
    );

}